type TFamily = 'default' | 'heading';

export function getFontFamily(type: TFamily = 'default') {
  if (type === 'heading') {
    return 'NB Architekt R';
  }
  return 'Inter';
}
